import {
  authLoadingAnimation,
  RateArrowIcon,
  Typography,
} from '@libs/components';
import Lottie from 'lottie-react';
import { SwapStatus } from 'src/constants';
import { useTheme } from 'styled-components';
import { CopyLink } from '../copy-link/CopyLink';

import {
  AssetContianer,
  AssetIconWrapper,
  AssetInfoTitle,
  AssetInfoWrapper,
  AssetRateContainer,
  Body,
  Container,
  CustomPendingIcon,
  FlexCenter,
  FlexColumn,
  Header,
  ProcessContainer,
  Image,
  LottieWrapper,
  AssetRateArrowWrapper,
  Footer,
  FooterInfoContainer,
  SwapDetailsButton,
  HeaderBodyWrapper,
  CustomCheckIcon,
} from './styles';

type SwapCardProps = {
  status: SwapStatus;
};

const SwapCard: React.FC<SwapCardProps> = ({ status }) => {
  const { colors } = useTheme();
  const checkStatusIsPendingOrConfirming =
    status === SwapStatus.PENDING_DEPOSIT || status === SwapStatus.CONFIRMING;

  return (
    <Container>
      <HeaderBodyWrapper>
        <Header>
          <AssetContianer>
            <AssetIconWrapper>
              <Image src="https://bitnet-dev-uploads.s3.eu-central-1.amazonaws.com/btc.svg" />
            </AssetIconWrapper>
            <AssetInfoWrapper>
              <AssetInfoTitle type="caption" fontFamily="primaryMedium">
                Deposited:
              </AssetInfoTitle>
              <Typography type="bodyButton" fontFamily="primaryBold">
                1.58 ETH
              </Typography>
            </AssetInfoWrapper>
          </AssetContianer>
          {checkStatusIsPendingOrConfirming && (
            <>
              <AssetRateContainer>
                <CopyLink
                  title="Deposit Hash"
                  description="123123123askjdbajks..djalsbdjka"
                  link="bitnet.ge"
                />
              </AssetRateContainer>
              <AssetRateContainer>
                <AssetInfoWrapper>
                  <AssetInfoTitle type="caption" fontFamily="primaryMedium">
                    Pending Blockchain Deposit
                  </AssetInfoTitle>
                  <Typography type="bodyButton" fontFamily="primaryBold">
                    6 min ago
                  </Typography>
                </AssetInfoWrapper>
              </AssetRateContainer>
            </>
          )}
          {!checkStatusIsPendingOrConfirming && (
            <>
              <AssetRateContainer>
                <AssetRateArrowWrapper>
                  <RateArrowIcon />
                </AssetRateArrowWrapper>
                <AssetInfoTitle type="caption" fontFamily="primaryMedium">
                  Estimated rate:
                </AssetInfoTitle>
                <Typography type="bodyButton" fontFamily="primaryBold">
                  1 ETH ≈ 2,340.75 USDT
                </Typography>
              </AssetRateContainer>
              <AssetContianer>
                <AssetIconWrapper>
                  <Image src="https://bitnet-dev-uploads.s3.eu-central-1.amazonaws.com/eth.svg" />
                </AssetIconWrapper>
                <AssetInfoWrapper>
                  <AssetInfoTitle type="caption" fontFamily="primaryMedium">
                    Estimated withdrawal amount:
                  </AssetInfoTitle>
                  <Typography type="bodyButton" fontFamily="primaryBold">
                    ≈ 3,698.39 USDT
                  </Typography>
                </AssetInfoWrapper>
              </AssetContianer>
            </>
          )}
        </Header>
        {!checkStatusIsPendingOrConfirming && (
          <Body>
            <ProcessContainer>
              <FlexCenter>
                <CustomPendingIcon isWaiting={true} />
                <AssetInfoTitle type="caption" fontFamily="primaryMedium">
                  Awaiting
                </AssetInfoTitle>
              </FlexCenter>
              <Typography type="bodyButton" fontFamily="primaryBold">
                0.32 ETH
              </Typography>
            </ProcessContainer>
            <ProcessContainer>
              <FlexCenter>
                <LottieWrapper>
                  <Lottie loop={true} animationData={authLoadingAnimation} />
                </LottieWrapper>
                <AssetInfoTitle type="caption" fontFamily="primaryMedium">
                  Exchanging
                </AssetInfoTitle>
              </FlexCenter>
              <FlexColumn>
                <Typography type="bodyButton" fontFamily="primaryBold">
                  842.67 USDT
                </Typography>
                <AssetInfoTitle type="caption" fontFamily="primaryMedium">
                  0.00 ETH
                </AssetInfoTitle>
              </FlexColumn>
            </ProcessContainer>
            <ProcessContainer>
              <FlexCenter>
                <LottieWrapper>
                  <Lottie loop={true} animationData={authLoadingAnimation} />
                </LottieWrapper>
                <AssetInfoTitle type="caption" fontFamily="primaryMedium">
                  Withdrawing
                </AssetInfoTitle>
              </FlexCenter>
              <FlexColumn>
                <Typography type="bodyButton" fontFamily="primaryBold">
                  842.67 USDT
                </Typography>
                <AssetInfoTitle type="caption" fontFamily="primaryMedium">
                  0.00 ETH
                </AssetInfoTitle>
              </FlexColumn>
            </ProcessContainer>
            <ProcessContainer>
              <FlexCenter>
                <CustomCheckIcon isWaiting={true} />
                <AssetInfoTitle type="caption" fontFamily="primaryMedium">
                  Withdrawn
                </AssetInfoTitle>
              </FlexCenter>
              <FlexColumn>
                <Typography type="bodyButton" fontFamily="primaryBold">
                  842.67 USDT
                </Typography>
                <AssetInfoTitle type="caption" fontFamily="primaryMedium">
                  0.00 ETH
                </AssetInfoTitle>
              </FlexColumn>
            </ProcessContainer>
          </Body>
        )}
      </HeaderBodyWrapper>
      <Footer>
        <FooterInfoContainer>
          <CopyLink
            title="Deposit Hash"
            description="123123123askjdbajks..djalsbdjka"
            link="bitnet.ge"
            color={colors.surface.default}
          />
          <FlexColumn>
            <AssetInfoTitle type="caption" fontFamily="primaryMedium">
              Deposit date
            </AssetInfoTitle>
            <Typography type="bodyButton" fontFamily="primaryBold">
              17:15 / 08.02.2024
            </Typography>
          </FlexColumn>
        </FooterInfoContainer>
        <FooterInfoContainer>
          <CopyLink
            title="Deposit Hash"
            description="123123123askjdbajks..djalsbdjka"
            link="bitnet.ge"
            color={colors.surface.default}
          />
        </FooterInfoContainer>
        <FlexCenter>
          <SwapDetailsButton>
            <Typography
              type="bodyButton"
              fontFamily="primaryBold"
              color={colors.text.default}
            >
              Swap Details
            </Typography>
          </SwapDetailsButton>
        </FlexCenter>
      </Footer>
    </Container>
  );
};
export default SwapCard;
